import { PRESUPUESTADOR_SELECT_STOCK, PRESUPUESTADOR_SPECIFICT_AMOUNT } from './constants'
import { loadFileAssociations } from '../../common/redux/actions'
import { clearOwnerFields } from '../redux/actions'
import { BFFAgent } from 'BFFAgent'

export function selectStock(id, selected, idColor = null) {
  return async (dispatch, getState) => {
    const { presupuestador } = getState(state => state)
    const selectedStock = presupuestador?.nuevo?.Stocks?.find(stock => stock.id === id)
    const stock_owner_id = selectedStock && presupuestador?.nuevo?.nuevo == false ? presupuestador?.nuevo?.owner_id : selectedStock?.owner_id
    const carlot = stock_owner_id ? await BFFAgent.Datamasters.getCarlot(stock_owner_id) : undefined 
    const stock_owner_name = carlot?.name
    let special_discount = presupuestador.special_discount
    let entregaUsados = presupuestador.entregaUsados
    let nuevo = presupuestador.nuevo
    let bonif_vehicle = presupuestador.bonif_vehicle || null

    let stock_id_selected = presupuestador.stock_id
    let stock_color = presupuestador.stock_color
    let stock_ubicacion = presupuestador.stock_ubicacion
    let stock_vin=  presupuestador.stock_vin
    let stock_sucursal= presupuestador.stock_sucursal
    let stock_estado= presupuestador.stock_estado
    
    if(selected) {
      //Borro las bonificaciones del auto nuevo cuando cambio la regla de precio.
      special_discount = 0
      //Borro las bonificaciones del auto usado cuando cambio la regla de precio.
      entregaUsados = presupuestador.entregaUsados.map(usado => {
        usado.take_improvement_amount = 0;
        usado.final_take_price = usado.updatedTakePrice || usado.original_price;
        
        return usado;

      });
      
      if(!presupuestador.bonif_vehicle) {
        //los guardo en un objeto bonif_vehicle para cuando elimine el vin
        bonif_vehicle = {
            stock_id : presupuestador.nuevo.bonification?.stock_id,
            specific_amount: presupuestador.nuevo.bonification?.specific_amount,
            specific_percentage : presupuestador.nuevo.bonification?.specific_percentage,
            specific_selected_operator : presupuestador.nuevo.bonification?.specific_selected_operator,
            specific_valid_to: presupuestador.nuevo.bonification?.specific_valid_to,
            stock_comment : presupuestador.nuevo.bonification?.stock_comment,
            specific_discount_detail: presupuestador.nuevo.bonification?.specific_discount_detail
        }
      } 

      if (id) {
        const { 
          stock_id, 
          specific_selected_operator, 
          specific_amount, 
          specific_percentage, 
          specific_valid_to,  
          stock_comment,
          specific_discount_detail } = presupuestador.nuevo.Stocks.find(stock => stock.id === id)?.Bonification || presupuestador.nuevo.bonification
        
        const specificDiscount = {stock_id, specific_selected_operator , specific_amount, specific_percentage, specific_valid_to,  stock_comment, specific_discount_detail }
        nuevo = {...presupuestador.nuevo, bonification: {...presupuestador.nuevo.bonification, ...specificDiscount}}

        dispatch({
          type: PRESUPUESTADOR_SPECIFICT_AMOUNT,
          specific_amount: specific_amount || 0,
        })

      } else {
        dispatch({
          type: PRESUPUESTADOR_SPECIFICT_AMOUNT,
          specific_amount: (presupuestador?.nuevo?.bonification?.specific_amount || 0) * -1,
        })
        nuevo = {...presupuestador.nuevo, bonification: {...presupuestador.nuevo.bonification, ...bonif_vehicle}}
        stock_id_selected = null
        stock_color = null
        stock_ubicacion = null
        stock_vin = null
        stock_sucursal= null
        stock_estado= null
      }
    }

    dispatch(loadFileAssociations({ id, type: 'STOCK' }))
    dispatch({
      type: PRESUPUESTADOR_SELECT_STOCK,
      data: {
        selectedStock: id,
        stock: selectedStock,
        stock_carlot: carlot,
        reservedColors: idColor ? [{color_id: idColor}] : null,
        special_discount,
        entregaUsados,
        nuevo,
        bonif_vehicle,
        stock_id: stock_id_selected,
        stock_color,
        stock_ubicacion,
        stock_vin,
        stock_sucursal,
        stock_estado,
        stock_owner_id,
        stock_owner_name
      },
    })
    dispatch(clearOwnerFields())
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_SELECT_STOCK:
      return {
        ...state,
        ...action.data
      }
    case PRESUPUESTADOR_SPECIFICT_AMOUNT:
      return {
        ...state,
        maxDiscount: state.maxDiscount + (action.specific_amount || 0),
      }

    default:
      return state
  }
}
